
import * as React from 'react';
import { BaseComponent, BaseComponentProps, BaseComponentState } from '../base/BaseComponent';
import { getAjaxhelper } from 'src/utils';
import { makeid, ModalWrapper } from 'src/core';
import { HotelBedCatalogData } from 'src/shared';
import { ShowRoomDetail } from './ShowRoomDetail';
// import { render } from 'react-dom';
type roomsDetail = {
    roomImages: string[],
    roomFacilities: HotelBedCatalogData.HotelsRoomsRoomFacilities[],
    facilitiesGlobalHotel: HotelBedCatalogData.HotelFacility[],
};
export interface ShowRoomsDetailProps extends BaseComponentProps {
    roomIds: string[];
    lang: string;
    roomsName: string[];
}
export interface ShowRoomsDetailState extends BaseComponentState {
    roomsDetail: { [roomId: string]: roomsDetail };
    requesting: boolean;
    roomOpen: boolean;
    roomCode: string;
    roomName: string;

}

export class ShowRoomsDetail extends BaseComponent<ShowRoomsDetailProps, ShowRoomsDetailState> {

    constructor(props: ShowRoomsDetailProps) {
        super(props);
        this.state = {
            roomsDetail: {}, requesting: true, roomOpen: false, roomCode: '', roomName: ''
        };
    }

    componentWillMount() {
        // this.ShowRoomsDetail(this.props.room);
        this.getData();
    }

    getData() {
        getAjaxhelper().post("/dynamics/hb-api/rooms-detail", { lang: this.props.lang, roomids: this.props.roomIds }).then(
            d => {

                this.setStateHelper(
                    st => {
                        st.roomsDetail = d;
                        st.requesting = false;
                    }
                );
            }).catch(exc => {
                console.log(exc);
            });
    }

    render() {
        if (this.state.haveReactError) {
            return this.renderErrorPanel();
        }
        if (this.state.requesting) {
            return this.renderLoadingPanel();
        }
        let rooms: any[] = [];
        let i = 0;
        for (let roomID of this.props.roomIds) {
            let imageUrl = "/assets/images/no-image.jpg";
            if (this.state.roomsDetail[roomID] && this.state.roomsDetail[roomID].roomImages && this.state.roomsDetail[roomID].roomImages.length > 0) {
                imageUrl = this.state.roomsDetail[roomID].roomImages[0];
                for (let c of this.state.roomsDetail[roomID].roomImages) {
                    imageUrl = c;
                }
            }
            if (i > 0) {
                rooms.push(<hr />);
            }
            rooms.push(<span style={{textTransform: 'capitalize', color: "#007AFF", fontWeight: 800}}> {this.props.roomsName[i].toLowerCase()}</span> );
            rooms.push(
                <div
                    key={makeid()}
                    style={{ width: 150, height: 100, background: `url("${imageUrl}")`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                    onClick={
                        () => {
                            this.setStateHelper(
                                st => {
                                    st.roomOpen = true;
                                    st.roomCode = roomID;
                                    st.roomName = this.props.roomsName[i];
                                }
                            );
                        }
                    }
                >
                    <span />
                </div>
            );
            i++;
        }
        let style2: ReactModal.Styles = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0, 0.75)',
                zIndex: 9999
            },
            content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                overflow: 'hidden',
                backgroundColor: '#fff',
                border: 0
            }
        };
        return (
            <div style={{maxWidth: 150}}>
                {rooms}
                <ModalWrapper
                    style={style2}
                    isOpen={this.state.roomOpen}
                    onRequestClose={this.hendlerRoomDetailClose}
                    role="dialog"
                    contentLabel="Minimal Modal Example"
                ><div className="show-room-detail">
                        <ShowRoomDetail roomId={this.state.roomCode} roomName={this.state.roomName} hendlerRoomDetailClose={this.hendlerRoomDetailClose} lang={this.props.lang} />
                    </div>
                </ModalWrapper>
            </div>
        );
    }

    private renderLoadingPanel(): JSX.Element {

        return <div className='loader' />;
    }

    hendlerRoomDetailClose: () => any = () => {
        this.setState({ roomOpen: false });
    }
}



// WEBPACK FOOTER //
// ./src/hotels/ShowRoomsDetail.tsx